module.exports = __webpack_public_path__ + "static/img/bg-best-cinematography.6bf0219.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/bg-best-cinematography.jpg
// module id = 310
// module chunks = 0